import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  subCategories: [],
  loading: false,
  error: null,
};

const subCategorySlice = createSlice({
  name: "subCategories",
  initialState,
  reducers: {
    fetchSubCategoryStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchSubCategorySuccess: (state, action) => {
      state.loading = false;
      state.subCategories = action.payload;
    },

    fetchSubCategoryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchSubCategoryStart,
  fetchSubCategorySuccess,
  fetchSubCategoryFailure,
} = subCategorySlice.actions;

export default subCategorySlice.reducer;
